<template>
  <div class="row">
    <b class="mb-2">{{ label }}</b>
    <div v-for="item in items" :key="item.id" class="col--sm--4 col--md--3 mb-4">
      <div @click="onClick(item.id)">
        <app-button btn-type="outline" full-width>
          {{ item.label }}
        </app-button>
        <div v-if="item.checked" class="icon-style">
          <smtt-icon icon="check-circle" color="green" width="25px" class="icon" />
        </div>
        <div v-else class="icon-style unchecked-icon"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/AppButton';

export default {
  name: 'CheckButton',
  components: { AppButton },
  props: {
    'label': {
      type: String,
      required: true
    },
    /* Expected objects in the array:
    {
      id: number,
      label: string,
      checked: boolean,
    }
    */
    'items': {
      type: Array,
      required: true,
      default: () => { return [] },
    }
  },
  data() {
    return {
      'isSelected': false,
    }
  },
  methods: {
    onClick(id) {
      this.$emit('selected', id);
    }
  },
}
</script>

<style scoped>
.icon-style {
  position: absolute;
  top: -8px;
  right: 5px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: white;
  border: solid 1px;
}

.unchecked-icon {
  border: solid 1px;
}

.icon {
  position: absolute;
  width: 20px;
  height: 20px;
  left: -3px;
  top: -3px;
}
</style>